import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { allArticles } from '@/mocks/articles';

export default function Footer() {
  const mainCategories = categories.slice(0, 7);
  const moreCategories = categories.slice(7);
  const footerArticles = allArticles.slice(0, 5);

  return (
    <footer className="bg-secondary-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-base mb-4">Catégories Mode</h4>
            <div className="w-8 h-px bg-primary-300 mb-4"></div>
            <ul className="space-y-2.5">
              {mainCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-base mb-4">Plus de Catégories</h4>
            <div className="w-8 h-px bg-accent-300 mb-4"></div>
            <ul className="space-y-2.5">
              {moreCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-base mb-4">Guides & SEO</h4>
            <div className="w-8 h-px bg-primary-300 mb-4"></div>
            <ul className="space-y-2.5">
              {footerArticles.map((a) => (
                <li key={a.slug}>
                  <Link
                    to={`/article/${a.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer line-clamp-1"
                  >
                    {a.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Tous les articles →
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-base mb-4">À Propos</h4>
            <div className="w-8 h-px bg-accent-300 mb-4"></div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              Hipobuy Spreadsheet — Plateforme affiliée mode &amp; data. Découvrez les meilleures catégories mode et optimisez vos données avec nos guides complets SEO.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer">
                <i className="ri-shopping-bag-line"></i>
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer">
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-baseline gap-2">
            <span className="font-heading font-bold text-xl text-foreground-900">Hipobuy</span>
            <span className="font-heading font-bold text-xl text-foreground-400">Spreadsheet</span>
            <span className="text-xs text-foreground-400 ml-2">— plateforme affiliée</span>
          </div>
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Hipobuy Spreadsheet. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}